/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DressingsInactivateAliases {
  FIELD_JUSTFY = 'field-justfy',
  FORM_DRESSINGS_INACTIVATE = 'form-dressings-inactivate',
  LAYOUT_DRESSINGS_INACTIVATE = 'layout-dressings-inactivate',
  PANEL_DRESSINGS_INACTIVATE = 'panel-dressings-inactivate',
  TEXT_AREA_JUSTIFY = 'text-area-justify',
}
export { DressingsInactivateAliases };
